import React, { useEffect, useState } from "react";
import { fetchTopFilms } from "../../utilities/funzioniApi";
import MediaCarousel from "../media/MediaCarousel";
import { formatAsItalianDate } from "../../utilities/date";

const TrendingMoviesSection = () => {
  const [movies, setMovies] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const loadTrendingMovies = async () => {
      try {
        setIsLoading(true);
        const filmsData = await fetchTopFilms();
        setMovies(filmsData);
      } finally {
        setIsLoading(false);
      }
    };

    loadTrendingMovies();
  }, []);

  return (
    <MediaCarousel
      title="Film in tendenza"
      items={isLoading ? [] : movies}
      emptyMessage={
        isLoading
          ? "Caricamento dei film in tendenza..."
          : "Nessun film disponibile al momento."
      }
      getHref={(movie) => `/movies/movie/${movie.id}`}
      getTitle={(movie) => movie.title}
      getSubtitle={(movie) => formatAsItalianDate(movie.release_date)}
      getImage={(movie) =>
        movie.poster_path
          ? `https://image.tmdb.org/t/p/w300${movie.poster_path}`
          : undefined
      }
      getBadge={(movie) =>
        movie.vote_average ? (Math.round(movie.vote_average * 10) / 10).toFixed(1) : undefined
      }
      getBadgeLabel={() => "Valutazione media"}
    />
  );
};

export default TrendingMoviesSection;
